import { render, staticRenderFns } from "./LicenseIndicator.vue?vue&type=template&id=5df02f07&"
import script from "./LicenseIndicator.vue?vue&type=script&lang=ts&"
export * from "./LicenseIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports